// import { CategoryOneContext } from "App";
import { Grid } from 'antd-mobile';
import CicleCell from 'components/item/cicle-cell/index';
import { useI18n } from 'i18n/useI18n';
// import { ListPageData } from "pages/webapp/list";
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCateCover } from 'utils/getCoverUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';

export type CellDataType = {
  key: any;
  title: string;
  cover: string;
  url: string;
  data?: any;
  index?: number;
};

const CateBar = () => {
  const { t } = useI18n();
  const [cateCount, setCateCount] = useState<number>(0);
  // const categoryOne = useContext(CategoryOneContext);
  const navigate = useNavigate();
  const [dataList, setDataList] = useState<CellDataType[]>();
  const ignore = useRef(false);

  // useEffect(() => {
  //   // if (ignore.current) return;
  //   const _dataList: CellDataType[] = categoryOne.map((item, index) => {
  //     return {
  //       key: item.uuid,
  //       title: item.typeName,
  //       cover: item.coverUrl,
  //       // url: "/cate2",
  //       url: "/list",
  //       data: item,
  //       index: index,
  //     };
  //   });
  //   _dataList.push({
  //     key: "vip",
  //     title: t("cate-bar.index.180777-0"),
  //     cover: img.vip,
  //     url: "/user",
  //   });
  //   _dataList.push({
  //     key: "cate",
  //     title: t("cate-bar.index.180777-1"),
  //     cover: img.cate,
  //     url: "/cate",
  //   });
  //   setDataList((dataList) => (dataList = _dataList));
  //   setCateCount((cateCount) => (cateCount = _dataList.length));
  //   // return () => {
  //   //   ignore.current = !ignore.current;
  //   // };
  // }, [categoryOne]);

  const CircleCellList = () => {
    return dataList?.map((item, index) => {
      return (
        <div>
          <CicleCell
            key={item.key as string}
            title={item.title}
            // cover={item.cover}
            // cover={cateCover[index][cateCoverIndex]}
            cover={index < dataList.length - 2 ? getCateCover(index) : item.cover}
            onClick={() => {
              if (item.key === 'vip') {
                navigate(getItemWithExpiration('userPolyInfo') != null ? item.url : '/login');
              } else if (item.key === 'cate') {
                navigate(item.url);
              } else {
                // navigate(item.url, {
                //   state: { ...item.data, index: item.index },
                // });
                // navigate("/list", {
                //   state: {
                //     type: 1,
                //     cate: item.data,
                //   } as ListPageData,
                // });
              }
            }}
          />
        </div>
      );
    });
  };

  return (
    <>
      {/* <Selecter /> */}
      {/* {categoryOne.length !== 0 && ( */}
      <div style={{ padding: '10px 10px' }}>
        <Grid columns={cateCount % 5 === 0 ? 5 : cateCount % 4 === 0 ? 4 : 3}>{CircleCellList()}</Grid>
      </div>
      {/* )} */}
    </>
  );
};

export default CateBar;
